import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { FaArrowLeft, FaUsers, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styles from "./Registration.module.css";
import Circle from "../../assets/Frame 155 circle.svg";
import OLogo from "../../assets/OGUN STATE LOGO 1 (1).png";
import House from "../../assets/household.png";
import Gov from "../../assets/government.png";
import Info from "../../assets/info-circle.png";
import { Modal } from "react-bootstrap";
// import { CheckCircle } from "lucide-react";
import { FiCheckCircle } from "react-icons/fi"; 
import Check from "../../assets/check-verified-02 (1).png"
import Clip from "../../assets/Icon (1).png"

const Registration = () => {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [idType, setIdType] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [contactForm, setContactForm] = useState(true);
  const [houseForm, setHouseForm] = useState(false);
  const [passwordForm, setPasswordForm] = useState(false);
  const [viewForm, setViewForm] = useState(false);
  

//   const [selected, setSelected] = useState(null);
//     const navigate = useNavigate();
  
  
    const [lga, setLga] = useState("");
    const [ward, setWard] = useState("");
    const [community, setCommunity] = useState("");
    const [address, setAddress] = useState("");
     const [checked, setChecked] = useState(false);
  
    // HOUSEHOLD COMPOSITION
    const [householdSize, setHouseholdSize] = useState("");
    const [maleMembers, setMaleMembers] = useState("");
    const [femaleMembers, setFemaleMembers] = useState("");
    const [children, setChildren] = useState("");
    const [elderly, setElderly] = useState("");
  
    // LIVELIHOOD
    const [incomeSource, setIncomeSource] = useState("");
    const [monthlyIncome, setMonthlyIncome] = useState("");
    const [housingCondition, setHousingCondition] = useState("");

    const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [securityQuestion, setSecurityQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => { 
    setShow(false) 
  };
  const handleShow = () => { 
    setShow(true) 
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      firstName,
      lastName,
      middleName,
      gender,
      dob,
      idType,
      idNumber,
      phone,
      email,
    };
    console.log(formData);
  };


  return (
     <div className={styles.wrapper}>
       {/* Final Screen that routes to login */}
         <Modal
      show={show}
      onHide={handleClose}
      centered
      // backdrop="static"
      className={styles.modalWrapper}
    >
      <Modal.Body className={styles.modalBody}>
        {/* Icon */}
        <div className={styles.iconWrapper}>
          <img src={Check} size={40} />
        </div>

        {/* Title */}
        <h3 className={styles.titless}>Application Submitted!</h3>

        {/* Subtitle */}
        <p className={styles.subtitless}>
          Your registration has been received. A field agent will contact you
          within 10–14 working days to schedule a verification visit
        </p>

        {/* Reference Box */}
        <div className={styles.refBox}>
          <span className={styles.refLabel}>YOUR REFERENCE NUMBER</span>
          <div className={styles.refNumber}>
            OG-HH-2026-04917
            {/* <span className={styles.copyIcon}>📋</span> */}
            <img src={Clip} size={20} className={styles.copyIcon} />
          </div>
        </div>

        {/* Button */}
        <button className={styles.loginBtn}>
          Login to Track Your Application
        </button>
      </Modal.Body>
    </Modal>        



      {/* <Row className="h-100"> */}

        {/* LEFT SECTION */}
          <div className={styles.leftSection}>
          <div className={styles.leftContent}>

            <div className={styles.logo}>
              <img src={OLogo} className={styles.logoImg} alt="logo" />
              <div className={styles.logoText}>
                <h6>OGUN STATE</h6>
                <p>Social Registry</p>
              </div>
            </div>

            <h2>
              Create your <span>account</span>
            </h2>

            <p className={styles.desc}>
              Register your household or create a staff account. It's free and
              takes about 5 minutes
            </p>

            <ul className={styles.list}>
              <li>Secure and confidential handling of your information</li>
              <li>Quick registration in under 5 minutes</li>
              <li>Simple step-by-step process</li>
              <li>Required for access to government support programs</li>
              <li>Option to save and continue later</li>
            </ul>
          </div>
        </div>

        {/* RIGHT SECTION  1*/}
        <div className={styles.rightSection}>
          <div className={styles.rightContent}>

            <div className={styles.back} onClick={() => navigate("/nin_reg")}>
              <FaArrowLeft style={{marginRight: "10px"}} /> Back to Home
            </div>

    {contactForm && (
            <>
                    {/* <div style={{ maxWidth: "800px", margin: "0 auto" }}> */}
                {/* <p className={styles.textind} >
                  STEP 3 OF 5
                </p> */}
                <p className={styles.textind} >
                  STEP 2 OF 4
                </p>
                <h4 className={styles.detText}>Household Information</h4>
                <p className={styles.mintext} >
                  Tell us about your household, location, and living situation
                </p>
        
                <Form 
                // onSubmit={handleSubmit}
                >
                  {/* Personal Info Section */}
                     <div className="mb-4">
            <h6 className={styles.subhead}>CONTACT INFORMATION</h6>
            <div className="border-top border-success mb-3" style={{ borderWidth: "3px" }} />

            <Row>
              <Col xs={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Phone Number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className={styles.finputs}
                  // />
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={styles.finputs}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>


                  <div className="mb-4">
                    <h6 className={styles.subhead}>LOCATION</h6>
                     <div className="border-top border-success mb-3" />
        
                       <Row>
                    <Col xs={12} md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>LGA</Form.Label>
                        <Form.Select className={styles.finputs} value={lga} onChange={(e) => setLga(e.target.value)}>
                          <option value="">Select LGA</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
        
                    <Col xs={12} md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label >Ward</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="enter ward name"
                          value={ward}
                          onChange={(e) => setWard(e.target.value)}
                          className={styles.finputs}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
        
                  <Row>
                    <Col xs={12} className="mb-3">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>Community/Village</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Name of Community/Village"
                          value={community}
                          onChange={(e) => setCommunity(e.target.value)}
                          className={styles.finputs}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
        
        
                  <Row>
                    <Col xs={12} className="mb-3">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>House Address</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter House Address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          className={styles.finputs}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                    
                    
                  </div>
        
                  {/* Identification Section */}
                  <div className="mb-4">
                    <h6 className={styles.subhead}>HOUSEHOLD COMPOSITION</h6>
                    <div className="border-top border-success mb-3" style={{ borderWidth: "3px" }} />
        
                     <Row>
                      <Col xs={12} md={4} className="mb-3">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>Household Size</Form.Label>
                        <Form.Select
                          className={styles.finputs}
                          value={householdSize}
                          onChange={(e) => setHouseholdSize(e.target.value)}
                        >
                          <option value="">Total</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
        
                    <Col xs={12} md={4} className="mb-3">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>Male Members</Form.Label>
                        <Form.Select
                          className={styles.finputs}
                          value={maleMembers}
                          onChange={(e) => setMaleMembers(e.target.value)}
                        >
                          <option value="">0</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
        
                    <Col xs={12} md={4} className="mb-3">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>Female Members</Form.Label>
                        <Form.Select
                          className={styles.finputs}
                          value={femaleMembers}
                          onChange={(e) => setFemaleMembers(e.target.value)}
                        >
                          <option value="">0</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
        
                  <Row>
                    <Col xs={12} md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>Children under 18</Form.Label>
                        <Form.Select
                          className={styles.finputs}
                          value={children}
                          onChange={(e) => setChildren(e.target.value)}
                        >
                          <option value="">0</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
        
                    <Col xs={12} md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>Elderly (60+)</Form.Label>
                        <Form.Select
                          className={styles.finputs}
                          value={elderly}
                          onChange={(e) => setElderly(e.target.value)}
                        >
                          <option value="">0</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  </div>
        
                  {/* Contact Info Section */}
                  <div className="mb-4">
                    <h6 className={styles.subhead}>LIVELIHOOD</h6>
                    <div className="border-top border-success mb-3" style={{ borderWidth: "3px" }} />
        
                    <Row>
                    <Col xs={12} className="mb-3 mt-2">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>Primary Source of Income</Form.Label>
                        <Form.Select
                          className={styles.finputs}
                          value={incomeSource}
                          onChange={(e) => setIncomeSource(e.target.value)}
                        >
                          <option value="">Select Primary Source of Income</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
        
                  <Row>
                    <Col xs={12} className="mb-3 mt-2">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>Estimated Monthly Income</Form.Label>
                        <Form.Select
                          className={styles.finputs}
                          value={monthlyIncome}
                          onChange={(e) => setMonthlyIncome(e.target.value)}
                        >
                          <option value="">Select Income Range</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
        
                  <Row>
                    <Col xs={12} className="mb-3 mt-2">
                      <Form.Group>
                        <Form.Label className={styles.flabels}>Housing Condition</Form.Label>
                        <Form.Select
                          className={styles.finputs}
                          value={housingCondition}
                          onChange={(e) => setHousingCondition(e.target.value)}
                        >
                          <option value="">Select Housing Condition</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  </div>
        
                  {/* Footer Buttons */}
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <button className={styles.btnback}><span style={{marginRight: "5px"}}
                    //  onClick={(e) => {
                    // e.preventDefault();
                    // setContactForm(true);
                    // setHouseForm(false);
                    // }}
                     onClick={(e) => {
                    e.preventDefault();
                    navigate("/nin_reg")
                    }}
                    >← </span>Back
                    </button>
                    <span className="text-muted">2 of 4</span>
                    <button className={styles.continueBtn}
                    onClick={() => {
                    setContactForm(false);
                    setPasswordForm(true);
                    }}
                    >
                      Continue
                    </button>
                  </div>
                </Form>
                </>
                  )}

            {houseForm && (
              <>  
            {/* <div style={{ maxWidth: "800px", margin: "0 auto" }}> */}
                <p className={styles.textind} >
          STEP 3 OF 5
        </p>
        <h4 className={styles.detText}>Set your password</h4>
        <p className={styles.mintext} >
          Create a password you will use to sign in and check your registration status
        </p>

        <Form 
        // onSubmit={handleSubmit}
        >
          {/* Personal Info Section */}
          <div className="mb-4">
            <div className="mb-3" style={{ borderWidth: "3px" }} />

            {/* <Row> */}
              <Col xs={12}  className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Password</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Create a Strong Password"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className={styles.finputs}
                  />
                </Form.Group>
              </Col>
            {/* </Row> */}
            
              <Col xs={12}  className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Confirm Password</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Re-Enter Your Password"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className={styles.finputs}
                  />
                </Form.Group>
              </Col>
{/* 
            <Row>
              <Col xs={12} className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Middle Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Middle Name"
                    value={middleName}
                    onChange={(e) => setMiddleName(e.target.value)}
                    className={styles.finputs}
                  // />
                  />
                </Form.Group>
              </Col>
            </Row> */}

            {/* <Row>
              <Col xs={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Gender</Form.Label>
                  <Form.Select
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                    className={styles.finputs}
                  >
                    <option value="">select gender</option>
                    <option>Male</option>
                    <option>Female</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    className={styles.finputs}
                  />
                </Form.Group>
              </Col>
            </Row> */}
          </div>

          {/* Identification Section */}
          <div className="mb-4">
            <h6 className={styles.subhead}>SECURITY  QUESTION</h6>
            <div className="border-top border-success mb-3" style={{ borderWidth: "3px" }} />

            {/* <Row> */}
              <Col xs={12}  className="mb-3">
                <Form.Group>
                   <Form.Label className={styles.flabels}>Security Question</Form.Label>
                <Form.Select className={styles.finputs}
                value={securityQuestion}
                onChange={(e) => setSecurityQuestion(e.target.value)}
                >
                <option value="">Choose a security question</option>
                <option>What is your mother’s maiden name?</option>
                <option>What was your first school?</option>
                <option>What is your favorite food?</option>
                </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12}  className="mb-3">
                <Form.Group>
                   <Form.Label className={styles.flabels}>Your Answer</Form.Label>
                    <Form.Control
                    type="text"
                    placeholder="Your Answer (case-sensitive)"
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    className={styles.finputs}
                    />
                    {/* </Form.Control> */}
                </Form.Group>
              </Col>
            {/* </Row> */}
          </div>

          {/* Contact Info Section */}
          {/* <div className="mb-4">
            <h6 className={styles.subhead}>CONTACT INFORMATION</h6>
            <div className="border-top border-success mb-3" style={{ borderWidth: "3px" }} />

            <Row>
              <Col xs={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Phone Number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className={styles.finputs}
                  // />
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={styles.finputs}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div> */}

          {/* Footer Buttons */}
          <div className="d-flex justify-content-between align-items-center mt-4">
            <button className={styles.btnback}
            // onClick={(e) => {
            //   e.preventDefault();
            // navigate("/nin_reg")
            // }}
            onClick={(e) => {
                    e.preventDefault();
                    setContactForm(true);
                    setHouseForm(false);
                    }}
            >← Back</button>
            <span className="text-muted">3 of 5</span>
            <button className={styles.continueBtn}
            // onClick={() => {
            // setContactForm(false);
            // setHouseForm(true);
            // }}
            onClick={(e) => {
                    e.preventDefault();
                    setContactForm(false);
                    setHouseForm(false);
                    setPasswordForm(true);
                    }}
            >
              Continue
            </button>
          </div>
        </Form>
        </>
        )}


            {passwordForm && (
              <>  
            {/* <div style={{ maxWidth: "800px", margin: "0 auto" }}> */}
                <p className={styles.textind}>
          STEP 3 OF 4
        </p>
        <h4 className={styles.detText}>Set your password </h4>     
        <p className={styles.mintext}>
          Please review your information carefully before submitting
        </p>

        <Form 
        // onSubmit={handleSubmit}
        >
          {/* Personal Info Section */}
          <div className="mb-4">
            <div className="mb-3" style={{ borderWidth: "3px" }} />

            {/* <Row> */}
              <Col xs={12}  className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Password</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Create a Strong Password"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className={styles.finputs}
                  />
                </Form.Group>
              </Col>
            {/* </Row> */}
            
              <Col xs={12}  className="mb-3">
                <Form.Group>
                  <Form.Label className={styles.flabels}>Confirm Password</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Re-Enter Your Password"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className={styles.finputs}
                  />
                </Form.Group>
              </Col>

          </div>

          {/* Identification Section */}
          <div className="mb-4">
            <h6 className={styles.subhead}>SECURITY  QUESTION</h6>
            <div className="border-top border-success mb-3" style={{ borderWidth: "3px" }} />

            {/* <Row> */}
              <Col xs={12}  className="mb-3">
                <Form.Group>
                   <Form.Label className={styles.flabels}>Security Question</Form.Label>
                <Form.Select className={styles.finputs}
                value={securityQuestion}
                onChange={(e) => setSecurityQuestion(e.target.value)}
                >
                <option value="">Choose a security question</option>
                <option>What is your mother’s maiden name?</option>
                <option>What was your first school?</option>
                <option>What is your favorite food?</option>
                </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12}  className="mb-3">
                <Form.Group>
                   <Form.Label className={styles.flabels}>Your Answer</Form.Label>
                    <Form.Control
                    type="text"
                    placeholder="Your Answer (case-sensitive)"
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    className={styles.finputs}
                    />
                    {/* </Form.Control> */}
                </Form.Group>
              </Col>
            {/* </Row> */}
          </div>

        

          {/* Footer Buttons */}
          <div className="d-flex justify-content-between align-items-center mt-4">
            <button className={styles.btnback}
            // onClick={(e) => {
            //   e.preventDefault();
            // navigate("/nin_reg")
            // }}
            onClick={(e) => {
                    e.preventDefault();
                    setContactForm(false);
                    setPasswordForm(false);
                    setHouseForm(true);
                    }}
            >← Back</button>
            <span className="text-muted">3 of 4</span>
            <button className={styles.continueBtn}
            // onClick={() => {
            // setContactForm(false);
            // setHouseForm(true);
            // }}
             onClick={(e) => {
                    e.preventDefault();
                    setContactForm(false);
                    setHouseForm(false);
                    setPasswordForm(false);
                    setViewForm(true);
                    }}
            >
              Continue
            </button>
          </div>
        </Form>
        </>
        )}
        

                {viewForm && (
              <>  
            {/* <div style={{ maxWidth: "800px", margin: "0 auto" }}> */}
                <p className={styles.textind}>
          STEP 4 OF 4
        </p>
        <h4 className={styles.detText}>Review & Submit</h4>     
        <p className={styles.mintext}>
          Please review your information carefully before submitting
        </p>

        {/* NOTE */}
            <div className={styles.notes}>
              <div className={styles.noteimg}>
                <img src={Info} alt="Circle" className={styles.infoIcon} />
              </div>
              <p>
                {/* <strong>Note:</strong> */}
                By submitting, you confirm that all information is accurate. A field agent may contact you to verify your registration
              </p>
            </div>

             <div className={styles.cards}>
        <div className={styles.cardHeader}>
          <span>PERSONAL DETAILS</span>
          <span className={styles.edit}>Edit</span>
        </div>

        <div className={styles.rows}>
          <span>Full Name</span>
          <p>Adunola Blessing Adeyemi</p>
        </div>

        <div className={styles.row}>
          <span>NIN</span>
          <p>******4917</p>
        </div>

        <div className={styles.row}>
          <span>Date of Birth</span>
          <p>14 March 1988</p>
        </div>

        <div className={styles.row}>
          <span>Email</span>
          <p>—</p>
        </div>

        <div className={styles.row}>
          <span>Password</span>
          <p>—</p>
        </div>
      </div>

      {/* HOUSEHOLD INFO */}
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <span>HOUSEHOLD INFO</span>
          <span className={styles.edit}>Edit</span>
        </div>

        <div className={styles.rows}>
          <span>LGA</span>
          <p>—</p>
        </div>

        <div className={styles.row}>
          <span>Ward</span>
          <p>—</p>
        </div>

        <div className={styles.row}>
          <span>Household Size</span>
          <p>—</p>
        </div>

        <div className={styles.row}>
          <span>Primary Income</span>
          <p>—</p>
        </div>
      </div>

      {/* Consent */}
      <div className={styles.consentBox}>
        <input
          type="checkbox"
          checked={checked}
          onChange={() => setChecked(!checked)}
        />
        <p>
          I confirm the information above is accurate and consent to the Ogun
          State Government processing this data for social welfare purposes.{" "}
          <span className={styles.link}>Read Privacy Policy</span>
        </p>
      </div>

         {/* Footer Buttons */}
          <div className="d-flex justify-content-between align-items-center mt-4">
            <button className={styles.btnback}
            // onClick={(e) => {
            //   e.preventDefault();
            // navigate("/nin_reg")
            // }}
            onClick={(e) => {
                    e.preventDefault();
                    setContactForm(false);
                    setPasswordForm(false);
                    setViewForm(false);
                    setHouseForm(false);
                    setPasswordForm(true);
                    }}
            >← Back</button>
            <span className="text-muted">4 of 4</span>
            <button className={styles.continueBtn}
            onClick={() => {
            // setContactForm(false);
            // setHouseForm(true);
            handleShow();
            }}
            //  onClick={(e) => {
            //         e.preventDefault();
            //         setContactForm(false);
            //         setHouseForm(false);
            //         setViewForm(true);
            //         }}
            >
              Continue
            </button>
          </div>
        </>
        )}


       

      </div>
        </div>

        
                {/* RIGHT SECTION 2*/}
                {/* <div className={styles.rightSection}>
                  <div className={styles.rightContent}>
        
                    <div className={styles.back} onClick={() => navigate("/")}>
                      <FaArrowLeft style={{marginRight: "10px"}} /> Back to Home
                    </div> */}

                 
              {/* </div> */}
        
                    {/* <hr /> */}
                   
                  {/* </div> */}
                {/* </div> */}
      {/* </Row> */}
    </div>
  );
};

export default Registration;